  <template>
  <div>
    <!-- <CCard columns class="card-columns cols-2"> -->
    <div class="mb-3">
      <CRow class="mb-3">
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Partner </label>
          <multiselect
            v-model="partnerSelected"
            placeholder="Seleccione un Partner"
            label="value"
            track-by="id"
            :options="partners"
            :close-on-select="true"
            :clear-on-select="false"
            :multiple="false"
            :taggable="false"
          ></multiselect>
          <!-- @input="getfilterPartner()" -->
        </div>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Business Unit </label>
          <treeselect
            v-if="!isLoading"
            v-model="businessunitSelected"
            :multiple="true"
            :options="businessUnits[0]"
            @input="getfilterbusinessUnit()"
          />
          <!-- :load-options="loadOptions" -->
        </div>

        <!-- <div class="col-md-4">
          <label class="typo__label  font-weight-bold"> Location</label>
          <treeselect
            v-if="!isLoading"
            v-model="locationSelected"
            :multiple="true"
            :options="locations1[0]"
            @input="getfilterlocationNamenew()"
          />
        </div> -->
        <!-- <div class="col-md-4">
          <label class="typo__label font-weight-bold"> Location </label>
          <multiselect
            v-model="locationSelected"
            placeholder="Seleccione un Location"
            :custom-label="customLabel"
            track-by="locationName"
            :options="locations"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterlocationName()"
            :multiple="true"
            :taggable="true"
            
          ></multiselect>
        </div> -->
        <div class="col-lg-4 col-md-12">
          <div>
            <label class="typo__label font-weight-bold">Date Created</label>
          </div>
          <date-picker
            v-model="range"
            range
            :shortcuts="shortcuts"
            confirm
            @change="dateSelected(range)"
          ></date-picker>
        </div>
      </CRow>
      <CRow>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> ScoreTag </label>
          <multiselect
            v-model="scoretagSelected"
            placeholder="Seleccione un ScoreTag"
            label="name"
            track-by="name"
            :options="scoreTags"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterscoreTag()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Rating </label>
          <multiselect
            v-model="starratingSelected"
            placeholder="Seleccione un Rating"
            label="name"
            track-by="value"
            :options="starRatings"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterstarRating()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>
        <!-- <div class="col-md-4">
          <label class="typo__label font-weight-bold"> Topics  </label>
          <multiselect
            v-model="topicSelected"
            placeholder="Seleccione un Topic"
            label="category_name"
            track-by="category_name"
            :options="topics"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterTopic()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div> -->

        <!-- @input="getfilterlocationNamePartner()" -->
      </CRow>
    </div>
    <CRow>
      <!-- <CCol class="col-6"> -->
      <CCol lg="6" md="12">
        <CCard>
          <div v-if="loader_scoretagcommentCount">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else>
            <CDataTable
              :items="scoretagcommentCount"
              hover
              striped
              bordered
              large
              fixed
              pagination
              :loading="isLoading"
              :fields="fields_data"
              caption="Different Values"
            >
              <!--  <template #business_unit_id="{ item }">
                <td>
                  {{ item[1] }}
                </td>
              </template> -->
            </CDataTable>
          </div>
        </CCard>
      </CCol>
      <!-- </CCol> -->
      <!-- <CCol class="col-6"> -->
      <CCol lg="6" md="12">
        <CCard>
          <CCardHeader
            >Graph with Sentiment Analysis (Score) results
          </CCardHeader>
          <CCardBody>
            <div v-if="loader_donutDatasets">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CChartDoughnut
                :datasets="donutDatasets"
                :labels="scoreTaglabel"
              />
            </div>
            <!-- "['P', 'P+', 'NONE', 'N', 'NEU', 'N+']" -->
          </CCardBody>
        </CCard>
      </CCol>
      <!-- </CCol> -->
    </CRow>

    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol sm="12" style="height: 500px; overflow-y: auto">
            <div v-if="loader_insights">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CDataTable
                :items="insights"
                hover
                striped
                bordered
                small
                fixed
                :loading="isLoadingdata"
                :fields="fields_data_large"
                column-filter
                sorter
              >
                <!-- pagination -->
                <template #createTime="{ item }">
                  <td>
                    {{ item.createTime | formatDate }}
                  </td>
                </template>

                <template #business_unit_id="{ item }">
                  <td>
                    {{ item.business_unit_id[1] }}
                  </td>
                </template>
              </CDataTable>
            </div>
            <div v-if="loadMore">
              <scroll-loader
                :loader-method="getstarRatingandCommentData"
                :loader-enable="loadMore"
              >
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="30"
                  color="blue"
                ></semipolar-spinner>
              </scroll-loader>
            </div>
          </CCol>
        </CCol>
      </CRow>
    </CCard>
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <div v-if="loader_barchart">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else class="barChart col-md-12">
            <!-- <bar-chart
              :height="300"
              :width="1000"
              :chart-data="barchartDatacollection"
            ></bar-chart> -->
            <CChartBar
              style="height: 400px"
              :datasets="barchartDatacollection.datasets"
              :labels="barchartDatacollection.labels"
              :options="{ maintainAspectRatio: false }"
            />
          </div>
        </CCol>
      </CRow>
    </CCard>
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <semipolar-spinner
            :animation-duration="2000"
            :size="30"
            color="blue"
            v-if="isLoading_apex_data"
          ></semipolar-spinner>
          <div id="chart-container" v-if="!isLoading_apex_data">
            <apexchart
              :height="400"
              :options="apex_dataconfig_data.dataSource.chartOptions"
              :series="apex_dataconfig_data.dataSource.series"
            ></apexchart>
          </div>
        </CCol>
      </CRow>
    </CCard>

    <CCol>
      <CRow>
        <CCol lg="6" md="12">
          <CCard>
            <div v-if="loader_piechartDatasets">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CChartPie
                :datasets="piechartDatasets"
                :labels="label_pie_chart"
                legendposition="right"
              />
            </div>
          </CCard>
        </CCol>

        <CCol lg="6" md="12">
          <CCard>
            <div id="chart-container">
              <div v-if="loader_barchartDatasets1">
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"
                ></semipolar-spinner>
              </div>
              <div v-else>
                <CChartBar
                  :height="300"
                  :width="400"
                  :datasets="barchartDatasets1"
                  :labels="label_barchart1"
                />
              </div>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CCol>

    <!-- <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol sm="12">
            <CDataTable
              :items="insights"
              hover
              striped
              bordered
              small
              fixed
              pagination
              :loading="isLoading"
              :fields="fields_data_star_rating"
            >
              <template #create_time="{ item }">
                <td>
                  {{ item.create_time | formatDate }}
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CCol>
      </CRow>
    </CCard> -->
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol md="12">
            <div v-if="loader_barchartDatasets2">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CChartBar
                :height="300"
                :width="1000"
                :datasets="barchartDatasets2"
                :labels="label_barchart2"
              />
            </div>
          </CCol>
        </CCol>
      </CRow>
    </CCard>
    <CCard class="center">
      <CRow>
        <CCol md="12" class="p-3">
          <div v-if="loader_barchartDatasets1">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else id="chart-container">
            <apexchart
              :height="500"
              :options="apex_dataconfig_data_radar.dataSource.chartOptions"
              :series="apex_dataconfig_data_radar.dataSource.series"
            ></apexchart>
          </div>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import store from "../../store";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";

import { CChartDoughnut, CChartPie, CChartBar } from "@coreui/vue-chartjs";
import BarChart from "./Barchart.js";

import VueApexCharts from "vue-apexcharts";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { SemipolarSpinner } from "epic-spinners";

import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ScrollLoader from "vue-scroll-loader";

export default {
  name: "Insight",
  components: {
    // ...Charts,
    DatePicker,
    DateRangePicker,
    CChartDoughnut,
    CChartPie,
    CChartBar,
    BarChart,
    apexchart: VueApexCharts,
    Multiselect,
    SemipolarSpinner,
    Treeselect,

    // FCComponent
  },
  data() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);
    return {
      demographicExcludeSelected: [],
      countriesIncludes: [
        {
          name: "Spain",
          id: 68,
          label: "Spain",
          code: "ES",
          children: null,
        },
      ],
      isLoading_apex_data: false,
      loader_scoretagcommentCount: false,
      loader_donutDatasets: false,
      loader_insights: false,
      loader_barchart: false,
      loader_piechartDatasets: false,
      loader_barchartDatasets1: false,

      loader_barchartDatasets2: false,
      loader_barchartDatasets2: false,
      loader_apex_radar: false,

      businessUnits: [[]],
      businessunitSelected: [],
      date: "",
      time: "",
      range: "",
      insights: [],
      loadMore: false,
      isLoadingdata: false,
      offset_insight: 0,

      insightsLocation: [],
      insightsArray: [],
      scoretagcommentCount: [],
      scoretagcommentCountArray: [],
      partners: [],
      partnersArray: [],
      analyzeinsightfirst: [],
      analyzeinsightfirstArray: [],
      analyzeinsightthird: [],
      analyzeinsightthirdArray: [],
      analyzeinsightfourth: [],
      analyzeinsightfourthArray: [],
      analyzeinsightfifth: [],
      analyzeinsightfifthArray: [],

      analyzeinsightfirstLocation: [],
      analyzeinsightthirdLocation: [],
      analyzeinsightfourthLocation: [],
      analyzeinsightfifthLocation: [],

      categories: [],
      partnerSelected: "",
      locations: [],
      locations1: [[]],
      locations2: [
        {
          id: "fruits",
          label: "Fruits",
          children: [
            {
              id: "apple",
              label: "Apple",
              isNew: true,
            },
            {
              id: "grapes",
              label: "Grapes",
            },
            {
              id: "pear",
              label: "Pear ",
            },
            {
              id: "strawberry",
              label: "Strawberry",
            },
            {
              id: "watermelon",
              label: "Watermelon",
            },
          ],
        },
        {
          id: "vegetables",
          label: "Vegetables",
          children: [
            {
              id: "corn",
              label: "Corn ",
            },
            {
              id: "carrot",
              label: "Carrot ",
            },
            {
              id: "eggplant",
              label: "Eggplant",
            },
            {
              id: "tomato",
              label: "Tomato",
            },
          ],
        },
      ],
      locationsArray: [],
      locationSelected: [],
      scoreTags: [],
      scoreTagsArray: [],
      scoretagSelected: "",
      starRatings: [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
        { name: 4, value: 4 },
        { name: 5, value: 5 },
      ],
      form_unique: [],
      form_uniqueSelected: "",
      starRatingsArray: [],
      starratingSelected: [],
      starratingSelectedValue: [],
      topics: [],
      topics_data: [],
      topicsArray: [],
      topicSelected: "",
      isLoading: false,
      commentCount: [],
      commentCountLocation: [],
      commentCountArray: [],
      score_data: [],
      score_dataArray: [],
      global_yearlyReviews: [],
      barchartscoredata: [],
      barchartscoredata_label: [],
      apexdata_label: [],
      apexdata_radar_label: [],
      dataset_apexchart: [],
      dataset_radar_apexchart: [],
      topic_starrating_data: [],
      topic_avg_starrating_data: [],
      form_count_data: [],
      topic_form_data: [],
      partner_ids: "",
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      apex_dataconfig_data: {
        dataSource: {},
      },
      apex_dataconfig_data_radar: {
        dataSource: {},
      },
      barchartDatacollection: { labels: [], datasets: [], options: {} },

      fields_data1: [
        { key: "business_unit_id", label: "Business Unit" },
        { key: "score_tag", label: "Score Tag" },
        { key: "count", label: "Comment" },
      ],
      fields_data: [
        { key: "business_unit_id_label", label: "Business Unit" },
        { key: "score_tag", label: "Score Tag" },
        { key: "__count", label: "Comment" },
      ],
      fields_data_large: [
        { key: "createTime", label: "Date" },
        { key: "business_unit_id", label: "Business Unit" },
        { key: "score_tag", label: "Score Tag" },
        { key: "starRating", label: "StarRating" },
        { key: "comment", label: "Original comment" },
        { key: "comment_eng", label: "Comment" },
      ],
      fields_data_star_rating: [
        { key: "create_time", label: "Date" },
        { key: "business_unit_name", label: "Business Unit" },
        { key: "star_rating", label: "Star Rating" },
        { key: "comment", label: "Original comment" },
        { key: "comment_eng", label: "Comment" },
      ],
      // apex_data:{},
      apex_data: {
        series: [],
        chartOptions: {},
      },
      apex_data_radar: {
        series: [],
        chartOptions: {},
      },
    };
  },

  mounted() {
    // this.getstarRating();
    // this.getCategoryNameTopics();
    // this.getdatastudioSentiment();
    // this.getdatastudioTopics();
    // this.locations1=[];
    this.getPartners();
    // this.getCountries();
    // this.getBusinessUnits();
    // this.getcommentCount();
    // this.getanalyzeInsightFirst();
    // this.getanalyzeInsightThird();
    // this.getanalyzeInsightFourth();
    // this.getanalyzeInsightFifth();
  },
  computed: {
    computedItems() {
      return insights.map((item) => {
        return {
          ...item,
          created_time: item.created_time,
          // registeredDate: item.registered.date
        };
      });
    },

    scoreTaglabel() {
      var scoretag_sorted = _.sortBy(this.score_data, "score_tag").reverse();
      return scoretag_sorted.map((item) => {
        if (item.score_tag != false) {
          // //console.log("item label :: ", item);
          return item.score_tag;
        }
      });
    },
    donutDatasets() {
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        " #CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        " #CCCCCC",
      ];
      var scoretag_sorted = _.sortBy(this.score_data, "score_tag").reverse();
      //console.log("scoretag_sorted in tp", scoretag_sorted, this.score_data);
      scoretag_sorted.forEach((scoretag, index) => {
        //console.log("scoretag", scoretag);
        if (scoretag.score_tag === "N") {
          backgroundColor[index] = "#7c7c7c";
          hoverBackgroundColor[index] = "#7c7c7c";
        }
        if (scoretag.score_tag === "N+") {
          backgroundColor[index] = "#eeff41";
          hoverBackgroundColor[index] = "#eeff41";
        }
        if (scoretag.score_tag === "NEU") {
          backgroundColor[index] = "#3d3d3d";
          hoverBackgroundColor[index] = "#3d3d3d";
        }
        if (scoretag.score_tag === "NONE") {
          backgroundColor[index] = "#D3C5FF";
          hoverBackgroundColor[index] = "#D3C5FF";
        }
        if (scoretag.score_tag === "P") {
          backgroundColor[index] = "#b08fff";
          hoverBackgroundColor[index] = "#b08fff";
        }
        if (scoretag.score_tag === "P+") {
          backgroundColor[index] = "#5700ff";
          hoverBackgroundColor[index] = "#5700ff";
        }
        if (!scoretag.score_tag) {
          backgroundColor[index] = "#CCCCCC";
          hoverBackgroundColor[index] = "#CCCCCC";
        }
      });
      //console.log("backgroundColor in tp::: ", backgroundColor);
      return [
        {
          backgroundColor: backgroundColor,
          data: scoretag_sorted.map((item) => {
            //console.log("item count :: ", item);
            if (item.score_tag !== false) return item.__count;
          }),
          legend: {
            position: "right",
            show: false,
          },
        },
      ];
    },
    piechartDatasets() {
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var topic_starrating_data_sorted = _.sortBy(
        this.topic_starrating_data,
        "category_id[1]"
      ).reverse();
      this.topic_starrating_data.forEach((category, index) => {
        //console.log(   "this.topic_starrating_data category",category.category_id[1]  );
        if (category.category_id != false) {
          if (category.category_id[1].split(" ")[1] === "Time") {
            backgroundColor[index] = "#eeff41";
            hoverBackgroundColor[index] = "#eeff41";
          }
          if (category.category_id[1].split(" ")[1] === "Price") {
            backgroundColor[index] = "#3d3d3d";
            hoverBackgroundColor[index] = "#3d3d3d";
          }
          if (category.category_id[1].split(" ")[1] === "Place") {
            backgroundColor[index] = "#D3C5FF";
            hoverBackgroundColor[index] = "#D3C5FF";
          }
          if (category.category_id[1].split(" ")[1] === "Location") {
            backgroundColor[index] = "#b08fff";
            hoverBackgroundColor[index] = "#b08fff";
          }
          if (category.category_id[1].split(" ")[1] === "Brand") {
            backgroundColor[index] = "#5700ff";
            hoverBackgroundColor[index] = "#5700ff";
          }
          if (category.category_id[1].split(" ")[1] === "Products") {
            backgroundColor[index] = "#7c7c7c";
            hoverBackgroundColor[index] = "#7c7c7c";
          }
          if (category.category_id[1].split(" ")[1] === "Staff") {
            backgroundColor[index] = "#CCCCCC";
            hoverBackgroundColor[index] = "#CCCCCC";
          }
          if (category.category_id[1] === "Others") {
            backgroundColor[index] = "#FAFF99";
            hoverBackgroundColor[index] = "#FAFF99";
          }
        }
      });
      //console.log("backgroundColor in barchartdata ::", backgroundColor);
      return [
        {
          backgroundColor: backgroundColor,
          data: topic_starrating_data_sorted.map((item) => {
            return item.count;
          }),
        },
      ];
    },
    barchartDatasets1() {
      return [
        {
          label: "Star Rating by group logic",
          backgroundColor: "#5700ff",
          data: this.topic_avg_starrating_data.map((item) => {
            return item.review_star_rating_avg;
          }),
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
              ],
            },
          },
        },
      ];
    },
    label_barchart1() {
      return this.topic_avg_starrating_data.map((item) => {
        return item.category_id[1];
      });
    },
    label_pie_chart() {
      return this.topic_starrating_data.map((item) => {
        return item.category_id[1];
      });
    },
    barchartDatasets2() {
      return [
        {
          label: "Topics Identified",
          backgroundColor: "#5700ff",
          data: this.form_count_data.map((item) => {
            return item.__count;
          }),
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          },
        },
      ];
    },
    label_barchart2() {
      // ////console.log("this.topics" , this.form_count_data);
      return this.form_count_data.map((item) => {
        return item.Form;
      });
    },
  },
  methods: {
    getfilterscoreTag() {
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];
      // this.scoretagSelected = "";
      // this.topicSelected = [];
      // this.starratingSelected = [];
      // this.range= [];

      var score_tags = [];
      this.scoretagSelected.forEach((score_tag) => {
        score_tags.push(score_tag.name);
      });
      //console.log("score_tags :::: ", score_tags);
      if (this.scoretagSelected.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
      } else {
        if (
          this.businessunitSelected.length > 0 ||
          this.partner_ids.length > 0
        ) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };

          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
        }
      }
    },
    getfilterTopic() {
      // this.scoretagSelected = "";
      // // this.topicSelected = "";
      // this.starratingSelected = [];
      // this.range= "";
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      var topics = [];
      this.topicSelected.forEach((topic) => {
        topics.push(topic.category_name);
      });
      //console.log("insights array here==>", this.insights);

      if (this.topicSelected.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
      } else {
        if (
          this.businessunitSelected.length > 0 ||
          this.partner_ids.length > 0
        ) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
        }
      }
    },
    getfilterstarRating() {
      //console.log("here starratingSelected", this.starratingSelected.length);
      // this.locationSelected = "";
      // this.partnerSelected = "";

      // this.scoretagSelected = "";
      // this.topicSelected = "";
      // this.range= "";
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      // this.starratingSelected = [];

      var starRatings = [];
      var ratingSelected = this.starratingSelected;

      this.starratingSelected.forEach((rating) => {
        starRatings.push(rating.value);
      });
      this.starratingSelectedValue = starRatings;
      //console.log("starRatings ########", starRatings);
      if (starRatings.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
      } else {
        // //console.log("this.partnerSelected None::::: ");
        if (
          this.businessunitSelected.length > 0 ||
          this.partner_ids.length > 0
        ) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = "";
        }
      }
    },
    customLabel({ locationName, city, description }) {
      return `${locationName} – ${city} – ${description}`;
    },
    getfilterlocationName() {
      //console.log("here ", this.locationSelected);
      // this.locationSelected ="";
      // this.scoretagSelected = "";
      // this.starratingSelected = [];
      // this.topicSelected = "";
      // this.range= "";
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];

      var location_names = [];
      var location_names_city = [];
      var location_names_desc = [];
      this.locationSelected.forEach((location) => {
        var key =
          location.locationName +
          " - " +
          location.city +
          " - " +
          location.description;
        location_names.push(key);
        location_names_city.push(location.city);
        location_names_desc.push(location.description);
      });
      // this.demographicExcludeSelected.forEach((location) => {
      //   location_names.push(location.locationName);
      //   location_names_city.push(location.city);
      //   location_names_desc.push(location.description);
      // });
      //console.log(   location_names, location_names_city,   location_names_desc,   "@@@@@location_names"     );
      var comment_data = this.commentCountArray;
      var insights = this.insightsArray;
      var analyzeinsightfirst = this.analyzeinsightfirstArray;
      var analyzeinsightthird = this.analyzeinsightthirdArray;
      var analyzeinsightfifth = this.analyzeinsightfifthArray;
      var analyzeinsightfourth = this.analyzeinsightfourthArray;
      ////console.log("filtered_data4 before :::: ", analyzeinsightthird.length);

      if (this.locationSelected.length > 0) {
        // var query = {location_name: this.locationSelected.location_name, city: this.locationSelected.city, description : this.locationSelected.description};

        // function search(data){
        //   return Object.keys(this).every((key) => data[key].includes(this[key]));
        // }
        //console.log(  comment_data.length,    location_names,    "   comment_data.length" );

        var filtered_data_comment = comment_data.filter((item) => {
          //console.log(   item, location_names.includes(    item.location_name +      " - " +      item.location_id.city +     " - " +      item.location_id.description  ),            "location_names.includes(item.location_name +' - '+item.location_id.city +' - '+item.location_id.description)");
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        //console.log( filtered_data_comment.length, "   filtered_data_comment.length"  );

        // this.commentCount = filtered_data_comment;

        // var result_comment_data = comment_data.filter(search, query);
        // //console.log("location_names, location_names_city, location_names_desc", location_names, location_names_city, location_names_desc, comment_data);
        // var filtered_data_comment = comment_data.filter(item =>{
        //   //console.log(location_names.includes(item.locationName) && location_names_city.includes(item.city) && location_names_desc.includes(item.description) ,"==============> ");
        //  location_names.includes(item.locationName) && location_names_city.includes(item.city) && location_names_desc.includes(item.description)});

        // //console.log("result_comment_data ::::: ", filtered_data_comment.length);
        this.commentCount = filtered_data_comment;

        var filtered_data_insight = insights.filter((item) => {
          //console.log("item in Insight", item);
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        this.insights = filtered_data_insight;

        var filtered_data_first = analyzeinsightfirst.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var analyzeinsightfirst_sorted = _.sortBy(
          filtered_data_first,
          "location_name"
        );
        this.analyzeinsightfirst = analyzeinsightfirst_sorted;

        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        var filtered_data3 = analyzeinsightthird.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        // ////console.log("filtered_data3  after:::: ", filtered_data3.length);

        var analyzeinsightthird_sorted = _.sortBy(
          filtered_data3,
          "location_name"
        );
        this.analyzeinsightthird = filtered_data3;

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);

        var filtered_data_fourth = analyzeinsightfourth.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var analyzeinsightfourth_sorted = _.sortBy(
          filtered_data_fourth,
          "location_name"
        );
        this.analyzeinsightfourth = analyzeinsightfourth_sorted;

        var filtered_data_fifth = analyzeinsightfifth.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var forms = [];
        var analyzeinsightfifth_sorted = _.sortBy(filtered_data_fifth, "form");
        ////console.log("after filter analyzeinsightfifth_sorted :::::::: ",analyzeinsightfifth_sorted);
        this.analyzeinsightfifth = filtered_data_fifth;

        this.commentCountLocation = filtered_data_comment;
        this.insightsLocation = filtered_data_insight;
        this.analyzeinsightfirstLocation = analyzeinsightfirst_sorted;
        this.analyzeinsightthirdLocation = analyzeinsightthird_sorted;
        this.analyzeinsightfourthLocation = analyzeinsightfourth_sorted;
        this.analyzeinsightfifthLocation = analyzeinsightfourth_sorted;

        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });
        this.getuniqueforms(forms);
        this.getformcount(analyzeinsightfifth_sorted);
      } else {
        this.insights = insights;
        this.commentCount = comment_data;
        var analyzeinsightfirst_sorted = _.sortBy(
          analyzeinsightfirst,
          "location_name"
        );

        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        var analyzeinsightthird_sorted = _.sortBy(
          analyzeinsightthird,
          "location_name"
        );

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);

        var analyzeinsightfourth_sorted = _.sortBy(
          analyzeinsightfourth,
          "location_name"
        );
        this.analyzeinsightfourth = analyzeinsightfourth_sorted;

        var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");

        var forms = [];
        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });
        this.getuniqueforms(forms);
        this.getformcount(analyzeinsightfifth_sorted);
      }
    },

    getfilterbusinessUnit() {
      //console.log("here ", this.businessunitSelected, this.partner_ids);
      // this.locationSelected ="";
      // this.scoretagSelected = [];
      // this.starratingSelected = [];
      // this.topicSelected = [];
      // this.range= [];
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      if (this.businessunitSelected.length > 0) {
        //console.log(  "this.businessunitSelected ::: ",this.businessunitSelected  );
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
      } else {
        // //console.log("this.partnerSelected None::::: ");
        if (this.partner_ids.length > 0) {
          this.getBusinessUnits();
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];

          this.dataset_apexchart = [];

          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
        }
      }
    },

    dateSelected(date) {
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      // this.scoretagSelected = [];
      // this.starratingSelected = [];
      // this.topicSelected = [];
      if (date[0] !== null || date[1] !== null) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
      } else {
        // //console.log("this.partnerSelected None::::: ");
        if (
          this.businessunitSelected.length > 0 ||
          this.partner_ids.length > 0
        ) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];

          this.dataset_apexchart = [];

          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];

          // this.demographicExcludeSelected=[];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = "";
          // this.insights = insights;
          // this.commentCount = comment_data;
          // var analyzeinsightfirst_sorted = _.sortBy(
          //   analyzeinsightfirst,
          //   "business_unit_id.name"
          // );

          // this.getComment_scoretagcount(analyzeinsightfirst_sorted);
          // this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
          // this.getComment_count(analyzeinsightfirst_sorted);

          // var analyzeinsightthird_sorted = _.sortBy(
          //   analyzeinsightthird,
          //   "business_unit_id.name"
          // );

          // this.getscoretagratingovertime2(analyzeinsightthird_sorted);
          // this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
          // this.apex_dataConfig();
          // this.apex_radar_dataConfig();
          // this.gettopic_starratingcount(analyzeinsightthird_sorted);
          // this.gettopic_starratingcount1(analyzeinsightthird_sorted);

          // var analyzeinsightfourth_sorted = _.sortBy(
          //   analyzeinsightfourth,
          //   "business_unit_id.name"
          // );
          // this.analyzeinsightfourth = analyzeinsightfourth_sorted;

          // var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");

          // var forms = [];
          // analyzeinsightfifth_sorted.forEach((item) => {
          //   if (item.form !== false) forms.push(item.form);
          // });

          // this.getuniqueforms(forms);
          // this.getformcount(analyzeinsightfifth_sorted);
        }
      }
    },
    resetanalyzeinsightFirst(analyzeinsightfirst) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfirst.length > 0) {
        // filtered_comment =;
        ////console.log("before filter analyzeinsightfirst :::::::: ",analyzeinsightfirst);
        var analyzeinsightfirst_sorted = analyzeinsightfirst;
        if (start !== null || end !== null) {
          var filtered_data = analyzeinsightfirst.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });

          analyzeinsightfirst_sorted = _.sortBy(
            filtered_data,
            "business_unit_id.name"
          );
        } else {
          analyzeinsightfirst_sorted = _.sortBy(
            analyzeinsightfirst,
            "business_unit_id.name"
          );
        }
        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        ////console.log("afterfilter analyzeinsightfirst_sorted:::::::: ",analyzeinsightfirst_sorted.length);

        // ////console.log("after filter :::::::: ",filtered_data);
      }
    },
    resetanalyzeinsightThird(analyzeinsightthird) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightthird.length > 0) {
        // filtered_comment =;
        //console.log(  "before filter analyzeinsightthird111111 :::::::: ", analyzeinsightthird);
        var analyzeinsightthird_sorted = analyzeinsightthird;
        if (start !== null || end !== null) {
          var filtered_data3 = analyzeinsightthird.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          analyzeinsightthird_sorted = _.sortBy(
            filtered_data3,
            "business_unit_id.name"
          );
        }
        ////console.log("after filter analyzeinsightthird :::::::: ",analyzeinsightthird);

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);
      }
    },
    resetanalyzeinsightFourth(analyzeinsightfourth) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfourth.length > 0) {
        ////console.log("before filter analyzeinsightfourth :::::::: ",analyzeinsightfourth);
        var filtered_data4 = analyzeinsightfourth;
        if (start !== null || end !== null) {
          var filtered_data4 = analyzeinsightfourth.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
        }
        this.analyzeinsightfourth = filtered_data4;
      }
    },
    resetanalyzeinsightFifth(analyzeinsightfifth) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfifth.length > 0) {
        ////console.log("before filter analyzeinsightfifth :::::::: ",analyzeinsightfifth);
        var analyzeinsightfifth_sorted = analyzeinsightfifth;
        var forms = [];
        if (start !== null || end !== null) {
          var filtered_data5 = analyzeinsightfifth.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          analyzeinsightfifth_sorted = _.sortBy(filtered_data5, "form");
          ////console.log("after filter analyzeinsightfifth_sorted :::::::: ",analyzeinsightfifth_sorted);

          analyzeinsightfifth_sorted.forEach((item) => {
            if (item.form !== false) forms.push(item.form);
          });
        }

        this.getuniqueforms(forms);

        this.getformcount(analyzeinsightfifth_sorted);
      }
    },
    resetInsight(insights) {
      var start = this.range[0];
      var end = this.range[1];
      if (insights.length > 0) {
        ////console.log("before filterinsight :::::::: ",insights);
        if (start !== null || end !== null) {
          var filtered_data_insight = insights.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          this.insights = filtered_data_insight;
          ////console.log("after filter insight :::::::: ",filtered_data_insight);
        } else {
          this.insights = insights;
        }
      }
    },
    resetCommentData(comment_data) {
      this.offset_insight = 0;
      var start = this.range[0];
      var end = this.range[1];
      if (comment_data.length > 0) {
        // filtered_comment =;
        //console.log("before filter comment_data :::::::: ", comment_data);
        if (start !== null || end !== null) {
          var filtered_data = comment_data.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          this.commentCount = filtered_data;
          //console.log("after filter comment_Data :::::::: ", filtered_data);
        } else {
          this.commentCount = comment_data;
        }
      }
    },

    // async loadOptions({ action, parentNode, callback }) {
    //   if (action === LOAD_CHILDREN_OPTIONS) {
    //     if (parentNode.hasOwnProperty("isState")) {
    //       await store.dispatch("getCityState", parentNode.id).then(() => {
    //         var result = store.getters.getCities;
    //         var regions = [];
    //         result.map(i => {
    //           var retorno = {
    //             id: i.id,
    //             label: i.name,
    //             name: i.name,
    //             country_id: i.country_id,
    //             state_id: i.state_id,
    //             isState: true
    //           };
    //           regions.push(retorno);
    //           return;
    //         });
    //         parentNode.children = regions;
    //         callback();
    //       });
    //     } else {
    //       await store.dispatch("getStateCountry", parentNode.id).then(() => {
    //         var result = store.getters.getStates;
    //         var regions = [];
    //         result.map(i => {
    //           var retorno = {
    //             id: i.id,
    //             code: i.code,
    //             label: i.name,
    //             name: i.name,
    //             country_id: i.country_id,
    //             children: null,
    //             isState: true
    //           };
    //           regions.push(retorno);
    //           return;
    //         });
    //         parentNode.children = regions;
    //         callback();
    //       });
    //     }
    //   }
    // },
    async getBusinessUnits() {
      var businessUnits = [];
      var partner_ids = this.partner_ids;
      var options = [];

      await store.dispatch("getBusinessUnits", partner_ids).then(() => {
        businessUnits = store.getters.getBusinessUnits;
        //console.log("businessUnits :::: ", businessUnits);
        // var businessunits_sorted = _.sortBy(businessUnits, "name" );
        var businessUnitByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        businessUnits.map((bu) => {
          if (partner_ids.includes(bu.partner_id[0])) {
            businessUnitByPartner.push(bu);
            var custom_label =
              bu.name + " - " + bu.city + " - " + bu.description;

            var key = bu.partner_id[1];
            if (prev_key !== key) {
              // //console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data, custom_label);
              if (data.some((loc) => loc.label === bu.partner_id[1])) {
                //console.log("already_exists");
                var index1 = _.findIndex(data, { label: bu.partner_id[1] });
                data[index1].children.push({
                  id: bu.id,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //console.log("doesnot exists");
                data.push({
                  id: bu.partner_id[0],
                  label: bu.partner_id[1],
                  children: [
                    {
                      id: bu.id,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              //console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, { label: bu.partner_id[1] });
              //console.log(  "!!!!!!!!!!1 ",     prev_key,    index1,    key,     data,    data[index1]    );

              data[index1].children.push({
                id: bu.id,
                label: custom_label,
                isNew: true,
              });
              //console.log( data[index1].children,  key,"data[index1].children",  custom_label   );
            }
          }
        });
        options.push(data);

        this.businessUnits = options;
      });

      //console.log("Business Unit after call", this.businessUnits);
    },
    async getlocation() {
      var gbalocation = store.getters.getlocationbyPartner;
      ////console.log("partner_ids", this.partner_ids);
      //console.log("item location1111 ::::::===>", gbalocation.length,this.isLoading );

      var options = [];
      // if (gbalocation.length === 0) {
      // this.isLoading = true;
      //console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      //console.log(partner_ids, "::::::::; partner_ids");
      store.dispatch("getlocationbyPartner", partner_ids).then(() => {
        gbalocation = store.getters.getlocationbyPartner;
        //console.log("gbalocation", gbalocation);
        var gbalocation_sorted = _.sortBy(
          gbalocation,
          "location.partner_id.name"
        );
        var locationsByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        //console.log("gbalocation :::: ", gbalocation);
        gbalocation_sorted.map((location) => {
          if (partner_ids.includes(location.partner_id.id)) {
            locationsByPartner.push(location);
            var custom_label =
              location.locationName +
              " - " +
              location.city +
              " - " +
              location.description;

            var key = location.partner_id.name;
            if (prev_key !== key) {
              //console.log("@@@@@@@@@@@@@@2 main ",prev_key, key, data,  custom_label  );
              if (data.some((loc) => loc.label === location.partner_id.name)) {
                //console.log("already_exists");
                var index1 = _.findIndex(data, {
                  label: location.partner_id.name,
                });
                data[index1].children.push({
                  id: custom_label,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //console.log("doesnot exists");
                data.push({
                  id: location.partner_id.name,
                  label: location.partner_id.name,
                  children: [
                    {
                      id: custom_label,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              // data={
              //   id: location.partner_id.name,
              //   label: location.partner_id.name,
              //   children: [{
              //     id: custom_label,
              //     label: custom_label,
              //     isNew: true,
              //   }],
              // };
              //console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, {
                label: location.partner_id.name,
              });
              //console.log(     "!!!!!!!!!!1 ",   prev_key,  index1,    key, data,  data[index1]  );

              data[index1].children.push({
                id: custom_label,
                label: custom_label,
                isNew: true,
              });
              //console.log( data[index1].children, key,ta[index1].children",  custom_label   );
            }
          }
        });
        //console.log("data ::: ", data);
        options.push(data);
        //console.log( "locationsByPartner ::::: ",options, locationsByPartner.length  );
        this.isLoading = false;

        this.locations = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        // this.locationsArray = _.sortBy(result, "locationName");
        this.locationsArray = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();

        this.locations1 = options;
        // //console.log("item location@@@: :::::===>", this.locations.length);
      });
      // } else {
      //   this.isLoading = false;
      //   var partner_ids = this.partner_ids;
      //   var locationsByPartner = [];

      //   // gbalocation.map((location) => {
      //   //   if (partner_ids.includes(location.partner_id.id)) {
      //   //     locationsByPartner.push(location);
      //   //   //console.log("locationsByPartner else ::::: ", location.locationName);
      //   //   }
      //   // });
      //   var prev_key = "";
      //   var data="";
      //   var gbalocation_sorted = _.sortBy(
      //       gbalocation,
      //       "locationName"
      //     );
      //   gbalocation_sorted.map((location) => {
      //   if (partner_ids.includes(location.partner_id.id)) {
      //         locationsByPartner.push(location);
      //         var custom_label = location.locationName +" - "+location.city +" - "+ location.description;

      //         var key = location.partner_id.name;
      //         //console.log("location.partner_id.id", key,  custom_label);
      //           // if (prev_key !== key) {
      //           //   //console.log("@@@@@@@@@@@@@@2 ", prev_key , data ,  key );
      //           //     data={
      //           //       id: location.partner_id.name,
      //           //       label: location.partner_id.name,
      //           //       children: [{
      //           //         id: custom_label,
      //           //         label: custom_label,
      //           //         isNew: true,
      //           //       }],
      //           //     };
      //           //     prev_key = key;
      //           // }else{
      //           //   var index1 = _.findIndex(data, {label: key});
      //           //   //console.log("!!!!!!!!!!1 else ", prev_key , key );
      //           //   data.children.push({
      //           //         id: custom_label,
      //           //         label: custom_label,
      //           //         isNew: true,
      //           //       })
      //           // }

      //           if (prev_key !== key) {

      //             //console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data);
      //             data.push({
      //                 id: location.partner_id.name,
      //                 label: location.partner_id.name,
      //                 children: [{
      //                   id: custom_label,
      //                   label: custom_label,
      //                   isNew: true,
      //                 }]
      //             });
      //               // data={
      //               //   id: location.partner_id.name,
      //               //   label: location.partner_id.name,
      //               //   children: [{
      //               //     id: custom_label,
      //               //     label: custom_label,
      //               //     isNew: true,
      //               //   }],
      //               // };
      //               //console.log("data ::: ", data);
      //               prev_key = key;
      //           }else{
      //             var index1 = _.findIndex(data1, {label: key});
      //             //console.log("!!!!!!!!!!1 ", prev_key ,index1,  key, data);

      //             data[index1].children.push({
      //                   id: custom_label,
      //                   label: custom_label,
      //                   isNew: true,
      //                 });
      //           }

      //          // var data = {
      //          //      id: location.partner_id.name,
      //          //      label: location.partner_id.name,
      //          //      children: [{
      //          //        id: custom_label,
      //          //        label: custom_label,
      //          //        isNew: true,
      //          //      }],
      //          //    };

      //       }

      //     });
      //       options.push(data);
      //   this.locations = _(locationsByPartner).chain().sortBy(function(location) {
      //                         return location.locationName;
      //                     }).sortBy(function(location) {
      //                         return location.city;
      //                     }).value();
      //   this.locationsArray = _(locationsByPartner).chain().sortBy(function(location) {
      //                         return location.locationName;
      //                     }).sortBy(function(location) {
      //                         return location.city;
      //                     }).value();
      //    this.locations1 = options;

      // }
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          this.partners = partners;
          this.partnersArray = partners;
          // this.partnerSelected.push(partners[0]);
          // this.getfilterPartner();

          ////console.log("partners ::::::::: ",this.partners);
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        ////console.log("partners ::::::::: ",partners);
        return;
      }
    },
    async getcommentCount() {
      var comment_count = store.getters.getcommentCountTP;
      if (comment_count.length == 0) {
        this.isLoading = true;
        await store.dispatch("getcommentCountTP").then(() => {
          comment_count = store.getters.getcommentCountTP;
          // this.partners = partners;
          // this.partnersArray = partners;
          ////console.log("comment_count ::::::::: ",comment_count);
          return;
        });
      } else {
        // this.comment_count = comment_count;
        // this.comment_countArray = comment_count;

        ////console.log("comment_count ::::::::: ",comment_count);
        return;
      }
    },
    async getanalyzeInsightFirst() {
      // var analyzeinsightfirst = store.getters.getanalyzeInsightFirst;
      // if (analyzeinsightfirst.length == 0) {
      this.isLoading = true;
      var analyzeinsightfirst = [];
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightFirstTP", partner_ids).then(() => {
        var analyzeinsightfirst = store.getters.getanalyzeInsightFirstTP;
        this.analyzeinsightfirst = analyzeinsightfirst;
        this.analyzeinsightfirstArray = analyzeinsightfirst;
        var analyzeinsightfirst_sorted = _.sortBy(
          analyzeinsightfirst,
          "location_name"
        );

        // ////console.log("analyzeinsightfirst ::::::::: ",analyzeinsightfirst);
        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightfirst = analyzeinsightfirst;
      //   this.analyzeinsightfirstArray = analyzeinsightfirst;
      //   // ////console.log("analyzeinsightfirst ::::::::: ",analyzeinsightfirst);
      //   var analyzeinsightfirst_sorted = _.sortBy(
      //     analyzeinsightfirst,
      //     "location_name"
      //   );
      //   this.getComment_scoretagcount(analyzeinsightfirst_sorted);
      //   this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
      //   this.getComment_count(analyzeinsightfirst_sorted);
      //   return;
      // }
    },
    async getanalyzeInsightThird() {
      // var analyzeinsightthird = store.getters.getanalyzeInsightThird;
      // if (analyzeinsightthird.length == 0) {
      this.isLoading = true;
      var analyzeinsightthird = [];
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightThirdTP", partner_ids).then(() => {
        var analyzeinsightthird = store.getters.getanalyzeInsightThirdTP;
        this.analyzeinsightthird = analyzeinsightthird;
        this.analyzeinsightthirdArray = analyzeinsightthird;
        var analyzeinsightthird_sorted = _.sortBy(
          analyzeinsightthird,
          "category_name"
        );

        ////console.log("analyzeinsightthird ::::::::: ",analyzeinsightthird);
        // analyzeinsightthird.forEach((thirddata)=>{
        // ////console.log("thirddata.create_time, thirddata.category_name, thirddata.avg_star_rating",thirddata.create_time, thirddata.category_name, thirddata.avg_star_rating);
        // })
        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);
        // this.getapexData(analyzeinsightthird_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightthird = analyzeinsightthird;
      //   this.analyzeinsightthirdArray = analyzeinsightthird;
      //   var analyzeinsightthird_sorted = _.sortBy(
      //     analyzeinsightthird,
      //     "category_name"
      //   );

      //   ////console.log("analyzeinsightthird ::::::::: ",analyzeinsightthird_sorted);

      //   this.getscoretagratingovertime2(analyzeinsightthird_sorted);
      //   this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
      //   this.apex_dataConfig();
      //   this.apex_radar_dataConfig();
      //   this.gettopic_starratingcount(analyzeinsightthird_sorted);
      //   this.gettopic_starratingcount1(analyzeinsightthird_sorted);
      //   return;
      // }
    },
    async getanalyzeInsightFourth() {
      // var analyzeinsightfourth = store.getters.getanalyzeInsightFourth;
      // if (analyzeinsightfourth.length == 0) {
      this.isLoading = true;
      var analyzeinsightfourth = [];
      var partner_ids = this.partner_ids;
      await store
        .dispatch("getanalyzeInsightFourthTP", partner_ids)
        .then(() => {
          var analyzeinsightfourth = store.getters.getanalyzeInsightFourthTP;
          this.analyzeinsightfourth = analyzeinsightfourth;
          this.analyzeinsightfourthArray = analyzeinsightfourth;
          var analyzeinsightfourth_sorted = _.sortBy(
            analyzeinsightfourth,
            "category_name"
          );

          ////console.log("analyzeinsightfourth111 ::::::::: ",analyzeinsightfourth_sorted);
          return;
        });
      // } else {
      //   this.analyzeinsightfourth = analyzeinsightfourth;
      //   this.analyzeinsightfourthArray = analyzeinsightfourth;
      //   var analyzeinsightfourth_sorted = _.sortBy(
      //     analyzeinsightfourth,
      //     "category_name"
      //   );

      //   ////console.log("analyzeinsightfourth ::::::::: ",analyzeinsightfourth_sorted);
      //   return;
      // }
    },
    async getanalyzeInsightFifth() {
      // var analyzeinsightfifth = store.getters.getanalyzeInsightFifth;
      // if (analyzeinsightfifth.length == 0) {
      var analyzeinsightfifth = [];
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightFifthTP", partner_ids).then(() => {
        var analyzeinsightfifth = store.getters.getanalyzeInsightFifthTP;
        this.analyzeinsightfifth = analyzeinsightfifth;
        this.analyzeinsightfifthArray = analyzeinsightfifth;

        var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");
        var forms = [];
        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });

        this.getuniqueforms(forms);

        this.getformcount(analyzeinsightfifth_sorted);

        ////console.log("analyzeinsightfifth222 ::::::::: ",analyzeinsightfifth_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightfifth = analyzeinsightfifth;
      //   this.analyzeinsightfifthArray = analyzeinsightfifth;
      //   ////console.log("analyzeinsightfifth ::::::::: ",analyzeinsightfifth);

      //   var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");
      //   var forms = [];
      //   analyzeinsightfifth_sorted.forEach((item) => {
      //     if (item.form !== false)
      //       forms.push({ name: item.form, value: item.form });
      //   });
      //   this.getuniqueforms(forms);
      //   this.getformcount(analyzeinsightfifth_sorted);
      //   return;
      // }
    },
    // async getdatastudioSentiment() {
    //   var insights = [];//store.getters.getdatastudioSentimentTP;

    //   var starRatings = [];
    //   var scoreTags = [];

    //   this.isLoading = true;
    //   var partner_ids = this.partner_ids;
    //   await store.dispatch("getdatastudioSentimentTP",  partner_ids).then(() => {
    //     insights = store.getters.getdatastudioSentimentTP;
    //     var insights_sorted = _.sortBy(insights, "business_unit_id.name");
    //     //console.log("insights@@@@ ::::::::: ", insights);
    //     this.insights = insights_sorted;
    //     this.insightsArray = insights_sorted;
    //     this.isLoading = false;
    //     return;
    //   });
    // },
    async getscoretagcommentCount() {
      var scoretagcommentCount = []; //store.getters.getdatastudioSentimentTP;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_scoretagcommentCount = true;

      await store.dispatch("getscoretagcommentCount", payload).then(() => {
        scoretagcommentCount = store.getters.getscoreTagCommentCount;
        // var insights_sorted = _.sortBy(insights, "business_unit_id.name");
        //console.log(coretagcommentCount@@@@ ::::::::: ",     scoretagcommentCount   );
        // this.scoretagcommentCount = scoretagcommentCount;
        // this.scoretagcommentCountArray = scoretagcommentCount;

        // this.getComment_count(scoretagcommentCount);
        this.getComment_scoretagcount(scoretagcommentCount);
        this.isLoading = false;
        this.loader_scoretagcommentCount = false;

        return;
      });
    },
    async getsentimentanalysisCount() {
      var sentimentanalysisCount = []; //store.getters.getdatastudioSentimentTP;

      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_donutDatasets = true;

      await store.dispatch("getsentimentanalysisCount", payload).then(() => {
        sentimentanalysisCount = store.getters.getsentimentanalysisCount;
        this.score_data = sentimentanalysisCount;
        this.score_dataArray = sentimentanalysisCount;

        // this.getComment_count(scoretagcommentCount);
        // this.getComment_scoretagcount(scoretagcommentCount);
        this.isLoading = false;
        this.loader_donutDatasets = false;

        return;
      });
    },
    async getstarRatingandCommentData() {
      var starRatingandCommentData = [];

      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
        offset: this.offset_insight,
      };
      this.loader_insights = true;

      await store.dispatch("getstarRatingandCommentData", payload).then(() => {
        starRatingandCommentData = store.getters.getstarRatingandCommentData;
        // this.insights = starRatingandCommentData;
        // this.insightArray = starRatingandCommentData;
        if (starRatingandCommentData.length > 0) {
          if (starRatingandCommentData.records.length > 0) {
            this.insights = [
              ...this.insights,
              ...starRatingandCommentData.records,
            ];
            this.insightsArray = [
              ...this.insightsArray,
              ...starRatingandCommentData.records,
            ];

            this.offset_insight += starRatingandCommentData.records.length;
            var aa = starRatingandCommentData.length - this.offset_insight;
            // //console.log("this.offset_location", aa, this.offset_insight, starRatingandCommentData.length)
            if (aa == 0) {
              this.loadMore = false;
            } else {
              this.loadMore = true;
            }
          }
        } else {
          this.insights = [];
          this.insightsArray = [];
          this.loadMore = false;
        }
        this.isLoading = false;
        this.loader_insights = false;

        return;
      });
    },
    async getscoretagratingovertime() {
      var scoretagratingovertime = [];
      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_barchart = true;

      await store.dispatch("getscoretagratingovertime", payload).then(() => {
        scoretagratingovertime = store.getters.getscoretagratingovertime;
        // //console.log("store.getters.getscoretagratingovertime  :: ", store.getters.getscoretagratingovertime);
        if (scoretagratingovertime.length > 0) {
          this.getscoretagratingovertime1(scoretagratingovertime);
        } else {
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
        }
        this.isLoading = false;
        this.loader_barchart = false;

        return;
      });
    },
    async getcategoryratingovertime() {
      var categoryratingovertime = [];
      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };

      await store.dispatch("getcategoryratingovertime", payload).then(() => {
        categoryratingovertime = store.getters.getcategoryratingovertime;
        //console.log(  "store.getters.categoryratingovertime  :: ",   categoryratingovertime.length);
        if (categoryratingovertime.length > 0) {
          this.getscoretagratingovertime2(categoryratingovertime);
        } else {
          this.apexdata_label = [];
          this.dataset_apexchart = [];
          this.categories = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
        }
        this.isLoading = false;
        return;
      });
    },
    async gettopicstarratingCount() {
      var topic_starratingcount = [];
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_piechartDatasets = true;

      await store.dispatch("gettopicstarratingCount", payload).then(() => {
        topic_starratingcount = store.getters.gettopicstarratingCount;
        //console.log(   "store.getters.gettopicstarratingCount  :: ",  topic_starratingcount      );

        if (topic_starratingcount.length > 0) {
          this.gettopic_starratingcount(topic_starratingcount);
        } else {
          this.topic_starrating_data = [];
        }
        this.isLoading = false;
        this.loader_piechartDatasets = false;

        return;
      });
    },
    async gettopicavgstarratingCount() {
      var topicavgstarratingCount = [];
      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_barchartDatasets1 = true;

      await store.dispatch("gettopicavgstarratingCount", payload).then(() => {
        topicavgstarratingCount = store.getters.gettopicavgstarratingCount;
        //console.log(   "store.getters.gettopicavgstarratingCount  :: ", topicavgstarratingCount);
        if (topicavgstarratingCount) {
          this.gettopic_starratingcount1(topicavgstarratingCount);
          this.getscoretagratingovertime_category(topicavgstarratingCount);
        } else {
          this.topic_avg_starrating_data = [];
          this.apexdata_radar_label = [];
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
        }
        this.isLoading = false;
        this.loader_barchartDatasets1 = false;

        return;
      });
    },
    async getformdataCount() {
      var formdataCount = [];
      this.isLoading = true;
      this.isLoading = true;
      var partner_ids = [];
      var business_unit_ids = [];
      var create_date = [];
      //console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.businessunitSelected.length > 0) {
        if (
          this.businessunitSelected.length === this.partner_ids.length &&
          this.businessunitSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          business_unit_ids = this.businessunitSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //console.log("this.starratingSelected.length ", topics);
      var location_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "business_unit",
      };
      this.loader_barchartDatasets2 = true;

      await store.dispatch("getformdataCount", payload).then(() => {
        formdataCount = store.getters.getformdataCount;
        //console.log("store.getters.getformdataCountCount  :: ", formdataCount);

        // this.topic_form_data = formdataCount;
        if (formdataCount.length > 0) {
          this.form_count_data = formdataCount;
        } else {
          this.form_count_data = [];
        }
        // this.gettopic_formcount(formdataCount);
        // this.getscoretagratingovertime_category(topicavgstarratingCount);
        var topics = [];
        formdataCount.forEach((topic) => {
          topics.push({ category_name: topic.Form });
        });
        this.getuniqueTopics(topics);
        this.isLoading = false;
        this.loader_barchartDatasets2 = false;
        return;
      });
    },
    async getstarRating() {
      // var insightsStarRating = store.getters.getdatastudioSentimentStarRating;
      var partner_ids = this.partner_ids;
      var starRatings = [];
      var scoreTags = [];
      // if (insightsStarRating.length == 0) {
      this.isLoading = true;

      await store
        .dispatch("getdatastudioSentimentStarRatingTP", partner_ids)
        .then(() => {
          var insightsStarRating =
            store.getters.getdatastudioSentimentStarRatingTP;

          var starRatingssorted = _.sortBy(insightsStarRating, "star_rating");
          var scoreTagsorted = _.sortBy(insightsStarRating, "score_tag");

          this.insightsStarRating = insightsStarRating;
          this.insightsStarRatingArray = insightsStarRating;

          // //console.log("starRatingssorted", starRatingssorted);
          // var x =[1,2,3,4,5]
          // var filtered_data3 = starRatingssorted.filter((item) => {
          //   return x.includes(item.star_rating);
          // });
          const starRatingunique = [
            ...new Map(
              starRatingssorted.map((item) => [item["star_rating"], item])
            ).values(),
          ];
          const scoreTagunique = [
            ...new Map(
              scoreTagsorted.map((item) => [item["score_tag"], item])
            ).values(),
          ];
          // //console.log("starRatingsunique", starRatingunique);
          var starRating = [];
          starRatingunique.forEach((star) => {
            if (star.star_rating !== false)
              starRating.push({
                name: star.star_rating,
                value: star.star_rating,
              });
            // if (topic.score_tag !== false)
            //   scoreTags.push({ name: topic.score_tag, value: topic.score_tag });
          });
          var scoreTags = [];
          scoreTagunique.forEach((score) => {
            if (score.star_rating !== false)
              scoreTags.push({
                name: score.score_tag,
                value: score.score_tag,
              });
          });
          this.starRatings = starRating;
          this.scoreTags = scoreTags;

          // this.getuniqueRatings(starRatingssorted);
          //console.log("======================>", starRating);
          this.isLoading = false;
          return;
        });
    },
    getscoretagratingovertime1(insights_sorted) {
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var scoreTags = [];
      insights_sorted.forEach((insight) => {
        // ////console.log("insights in getscoretagratingovertime1 ::::::::: ",insight);

        // if(insight.star_rating !==false)
        //   starRatings.push({"name":topic.star_rating, "value":topic.star_rating});
        if (insight.score_tag !== false)
          scoreTags.push({ name: insight.score_tag, value: insight.score_tag });
      });
      // ////console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniquescoreTags(scoreTags);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate = moment().endOf("month").format("DD MMM YYYY");
      // var startDate = moment()
      //   .subtract(1, "year")
      //   .add(1, "month")
      //   .startOf("month")
      //   .format("DD MMM YYYY");
      ////console.log("startDate======", startDate);
      ////console.log("endDate======111", endDate);
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o["createTime:month"] + "-" + o.score_tag;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                month: "",
              });
            // ////console.log("key in score::::::::", key);
            if (prev_key !== key) {
              item.count += o.__count;
              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
            } else item.count += o.__count;

            // ////console.log("key, item", key, item, item.month)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;
      // this.barchartscoredata_label = months;
      // this.barchartDatacollection.label = months;
      this.barchartscoredata_label = [...new Set(months)];
      this.barchartDatacollection.label = [...new Set(months)];

      this.barchartdata(result_monthdata);
      //console.log("result_monthdata", months, result_monthdata);
    },

    getscoretagratingovertime2(insights_sorted) {
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var categories = [];
      insights_sorted.forEach((insight) => {
        //console.log("insight", insight);
        if (insight.category_id !== false)
          categories.push(insight.category_id[1]);
        //console.log("Insight category_name", insight.category_id);
      });
      // ////console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniqueCategories(categories);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");
      ////console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
      ////console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted1.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      // ////console.log("filtered_data", filtered_data);
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o["review_create_time:month"] + "-" + o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                month: "",
              });
            // ////console.log("key in score::::::::", key);
            if (prev_key !== key) {
              item.count += o.__count;

              prev_key = key;
              item.month = o["review_create_time:month"];
              if (!months.includes(o["review_create_time:month"]))
                months.push(o["review_create_time:month"]);
            } else {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
            }
            // ////console.log("key, item", key, item, item.month)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;
      this.apexdata_label = months;
      // this.apexdata_radar_label = months;

      this.getapexData(result_monthdata);
      // this.getapexradarData(result_monthdata);
      //console.log("result_monthdata apex $$$$$$$$$$$$$",  months,   result_monthdata );
    },
    getscoretagratingovertime_category(insights_sorted) {
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var categories = [];
      insights_sorted.forEach((insight) => {
        if (insight.category_id !== false)
          categories.push(insight.category_id[1]);
      });
      // ////console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniqueCategories(categories);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");

      ////console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
      ////console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted1.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      // ////console.log("filtered_data", filtered_data);
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o.category_id[1];
            // const key =  moment(o.create_time).format('MMM YYYY') + '-' + o.category_name ;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                sum_avg_star_rating: 0,
                month: "",
              });
            // ////console.log("key in score::::::::", key);
            if (prev_key !== key) {
              item.count += 1;
              // item.sum_avg_star_rating += o.avg_star_rating;
              prev_key = key;
            } else {
              item.count += 1;
            }
            // ////console.log("key, item", key, item, item.month)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;
      // this.apexdata_label = months;
      this.apexdata_radar_label = this.categories;

      // this.getapexData(result_monthdata);
      this.getapexradarData(result_monthdata);
      //console.log( "result_monthdata apex $$$$$$$$$$$$$",  months, result_monthdata,this.apex_data  );
    },
    gettopic_starratingcount(topic) {
      var count = 0;
      var prev_key = "";
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                // instances: 0
              });
            //console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              item.count += o.__count;
              prev_key = key;
            } else item.count += o.__count;
            // }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      // this.topic_starrating_data=result_star_rating;
      var result_star_rating1 = [];
      result_star_rating.forEach((rating) => {
        if (rating.category_id[1] !== false) result_star_rating1.push(rating);
      });
      this.topic_starrating_data = result_star_rating1;

      // ////console.log("this.topic_starrating_data", this.topic_starrating_data);
    },

    gettopic_starratingcount1(topic) {
      // ////console.log("key in gettopic_starratingcount1:::::::: topic", topic);
      var count = 0;
      var avg_star_rating = 0;
      var sum_avg_star_rating = 0;
      var star_rating = 0;
      var prev_key = "";
      var total_avg_star_rating = [];
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                sum_avg_star_rating: 0,
                total_avg_star_rating: 0,
                month: "",
              });
            // ////console.log("key in gettopic_starratingcount1::::::::", o.avg_star_rating);
            if (prev_key !== key) {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
              prev_key = key;
              // item.month = o.create_time).format("MMM YYYY");
            } else {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
            }

            // ////console.log("key, item", item.sum_avg_star_rating);
            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // ////console.log("item  chart", item.category_name, total_avg_star_rating);
      var result_star_rating1 = [];
      // result_star_rating.forEach((rating) => {
      //   if (rating.category_name !== false) {
      //     var total = rating.sum_avg_star_rating / rating.count;
      //     rating.sum_avg_star_rating = parseFloat(total).toFixed(1);
      //     result_star_rating1.push(rating);
      //   }
      // });
      //console.log("result_star_rating ::: ", result_star_rating);
      this.topic_avg_starrating_data = result_star_rating;
      //console.log("result_star_rating 3137 ::: ", result_star_rating);
    },

    getformcount(form) {
      var count = 0;
      var prev_key = "";
      const result_form_count = [
        ...form
          .reduce((r, o) => {
            // if(o.count > 1 ){
            const key = o.form;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                // instances: 0
              });
            // ////console.log("key in score::::::::", key);
            if (key !== "false") {
              if (prev_key !== key) {
                item.count += 1;
                prev_key = key;
              } else item.count += 1;
            }
            // }else{
            //   ////console.log("no match false", key);
            // }
            return r.set(key, item);
            // }
          }, new Map())
          .values(),
      ];

      var result_form_count1 = _.sortBy(result_form_count, "count").reverse();
      this.form_count_data = result_form_count1;
      ////console.log("result_form_count ::::: ", result_form_count);
    },

    gettopic_formcount(topic) {
      var count = 0;
      var prev_key = "";
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.topic_form;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                // instances: 0
              });
            // ////console.log("key in score::::::::", key);
            if (key !== "false") {
              if (prev_key !== key) {
                item.count += 1;
                prev_key = key;
              } else item.count += 1;
            } else {
              ////console.log("no match false", key);
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      this.topic_form_data = result_star_rating;
      // ////console.log("this.topic_form_data", this.topic_form_data);
    },
    getComment_scoretagcount(insights_sorted) {
      var count = 0;
      var prev_key = "";
      const result_score_tag = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o.business_unit_id[1] + "-" + o.score_tag;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                business_unit_id_label: "",
                // instances: 0
              });
            if (key !== "false") {
              if (prev_key !== key) {
                item.count += 1;
                item.business_unit_id_label = o.business_unit_id[1];
                prev_key = key;
                // //console.log("key in score::::::::", key, item.count);
              } else item.count += 1;
            } else {
              ////console.log("no match false", key);
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // var scoretags = [];
      // result_score_tag.forEach((item) => {
      //   if (item.score_tag !== false)
      //     scoretags.push(item);
      // });
      // var result_score_tag = result_score_tag.filter((item) => {
      //     return result_score_tag.score_tag !== false
      //   });
      // this.score_data = scoretags;
      // this.score_dataArray = scoretags;
      //console.log("result_score_tag ::: ", result_score_tag);
      this.scoretagcommentCount = result_score_tag;
      this.scoretagcommentCountArray = result_score_tag;

      // //console.log("this.score_data", this.score_data);
    },
    getComment_count(insights_sorted) {
      var count = 0;
      var location_label = "";
      var prev_key = "";
      // //console.log("insights_sorted::::::::", insights_sorted);
      const result = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o.business_unit_id[1] + "-" + o.score_tag;
            // //console.log("insight key::::::::", key);
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                location_label: "",
                // instances: 0
              });
            if (prev_key !== key) {
              item.count += 1;
              prev_key = key;
              item.location_label = o.business_unit_id[1];
              // //console.log("insight key::::::::", key, location_label);
            } else {
              item.count += 1;
            }
            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      //console.log("result11111111111::::", result);
      // this.commentCount = result;
      // this.commentCountArray = result;
      this.scoretagcommentCount = result;
      this.scoretagcommentCountArray = result;
    },
    getuniqueRatings(starRatings) {
      const starRatingunique = [
        ...new Map(starRatings.map((item) => [item["name"], item])).values(),
      ];

      this.starRatings = _.sortBy(starRatingunique, "name");
    },
    getuniqueforms(forms) {
      const formunique = [
        ...new Map(forms.map((item) => [item["name"], item])).values(),
      ];
      // formunique.sort(function (a, b) {
      //         return a - b;
      //       });
      this.form_unique = _.sortBy(formunique, "name"); //formunique;
      ////console.log(this.form_unique, "<============formunique");
    },
    getuniqueCategories(categories) {
      const categoryunique = Array.from(new Set(categories));
      categoryunique.sort(function (a, b) {
        return a - b;
      });
      this.categories = categoryunique;
    },
    getuniquescoreTags(scoreTags) {
      const scoreTagunique = [
        ...new Map(scoreTags.map((item) => [item["name"], item])).values(),
      ];
      // ////console.log("topic.score_tag", scoreTagunique);
      this.scoreTags = _.sortBy(scoreTagunique, "name");
    },
    async getdatastudioTopics() {
      // var topics = store.getters.getdatastudioTopics;
      // if (topics.length == 0) {
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      var topics = [];
      // //console.log(partner_ids, " :::::::::: partner_ids in topics");
      await store.dispatch("getdatastudioTopicsTP", partner_ids).then(() => {
        topics = store.getters.getdatastudioTopicsTP;
        ////console.log("store.getters.getdatastudioTopics ::: ", store.getters.getdatastudioTopics);
        // this.getuniqueTopics(topics);
        this.topics_data = topics;
        this.topicsArray = topics;
        // // ////console.log("topics.length", topics.length);
        // var topics_sorted = _.sortBy(topics, "category_name");

        return;
      });
      // } else {
      //   this.topics_data = topics;
      //   this.topicsArray = topics;
      //   ////console.log("store.getters.getdatastudioTopics11 ::: ", topics);
      //   this.getuniqueTopics(topics);

      //   return;
      // }
    },
    async getCategoryNameTopics() {
      // var topics = store.getters.getdatastudioTopics;
      // if (topics.length == 0) {
      var partner_ids = this.partner_ids;
      this.isLoading = true;
      await store.dispatch("getCategoryNameTopicsTP", partner_ids).then(() => {
        var topics = store.getters.getdatastudioTopicsTP;
        ////console.log("store.getters.getdatastudioTopics ::: ", store.getters.getdatastudioTopics);
        // this.getuniqueTopics(topics);
        // //console.log("topics category_name ", topics);
        // this.topics_data = topics;
        // this.topicsArray = topics;
        // ////console.log("topics.length", topics.length);
        const topicsunique = [
          ...new Map(
            topics.map((item) => [item["category_name"], item])
          ).values(),
        ];

        //console.log("topics category_name111111 ", topicsunique);

        this.topics = _.sortBy(topicsunique, "category_name");
        // this.topics = topics;
        this.topicsArray = _.sortBy(topicsunique, "category_name");

        var topics_sorted = _.sortBy(topics, "category_name");

        return;
      });
      // } else {
      //   this.topics_data = topics;
      //   this.topicsArray = topics;
      //   ////console.log("store.getters.getdatastudioTopics11 ::: ", topics);
      //   this.getuniqueTopics(topics);

      //   return;
      // }
    },
    getuniqueTopics(topics) {
      const topicsunique = [
        ...new Map(
          topics.map((item) => [item["category_name"], item])
        ).values(),
      ];

      this.topics = _.sortBy(topicsunique, "category_name");
      // this.topics = topics;
      this.topicsArray = _.sortBy(topicsunique, "category_name");

      ////console.log("topics ::::::::: ",topicsunique);
    },

    apex_dataConfig() {
      this.apex_dataconfig_data = {
        dataSource: this.apex_data,
      };
    },
    apex_radar_dataConfig() {
      this.apex_dataconfig_data_radar = {
        dataSource: this.apex_data_radar,
      };
    },
    getapexData(result_monthdata) {
      // //console.log("result_monthdata apex ========", result_monthdata);

      var dataset_apexchart = [];
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      this.categories.sort();
      //console.log("this.categories ", this.categories, this.apexdata_label);
      this.categories.forEach((category, index) => {
        if (category.split(" ")[1] === "Time") {
          backgroundColor[index] = "#eeff41";
          hoverBackgroundColor[index] = "#eeff41";
        }
        if (category.split(" ")[1] === "Price") {
          backgroundColor[index] = "#3d3d3d";
          hoverBackgroundColor[index] = "#3d3d3d";
        }
        if (category.split(" ")[1] === "Place") {
          backgroundColor[index] = "#D3C5FF";
          hoverBackgroundColor[index] = "#D3C5FF";
        }
        if (category.split(" ")[1] === "Location") {
          backgroundColor[index] = "#b08fff";
          hoverBackgroundColor[index] = "#b08fff";
        }
        if (category.split(" ")[1] === "Brand") {
          backgroundColor[index] = "#5700ff";
          hoverBackgroundColor[index] = "#5700ff";
        }
        if (category.split(" ")[1] === "Products") {
          backgroundColor[index] = "#7c7c7c";
          hoverBackgroundColor[index] = "#7c7c7c";
        }
        if (category.split(" ")[1] === "Staff") {
          backgroundColor[index] = "#CCCCCC";
          hoverBackgroundColor[index] = "#CCCCCC";
        }
        if (category === "Others") {
          backgroundColor[index] = "#FAFF99";
          hoverBackgroundColor[index] = "#FAFF99";
        }

        //console.log(    "category name :::: ",  category.split(" ")[1],  backgroundColor[index]  );
        //console.log( "backgroundColor[index], scoretag ::: ",  backgroundColor[index]);

        this.isLoading_apex_data = true;
        var apexdata = [];
        this.apexdata_label.forEach((month) => {
          // ////console.log("month in apexdata $$$$$$$$$$", month);
          var count = 0;
          var avg_star_rating = 0;
          var star_rating = 0;
          result_monthdata.forEach((item) => {
            if (
              month === item["review_create_time:month"] &&
              category == item.category_id[1]
            ) {
              // //console.log(" category ::: item.category_name :: " ,category , item.month ,item.sum_avg_star_rating);
              count = item.count;
              star_rating = item.review_star_rating_avg;
              if (star_rating === 0 && count == 0) {
                avg_star_rating = 0;
              } else {
                avg_star_rating = star_rating / count;
              }
            }
          });
          // ////console.log("avg_star_rating ::::::::",star_rating, count,avg_star_rating ?0:avg_star_rating);
          // ////console.log("item for each month :: ", month, scoretag.name, count);

          apexdata.push(parseFloat(star_rating.toFixed(2)));
        });
        // //console.log("apex_data123 =========> ", apexdata);
        dataset_apexchart.push({
          data: apexdata,
          name: category,
        });
        ////console.log("category in apexdata  $$$$$$$$$$", apexdata , category, index ,backgroundColor[index], hoverBackgroundColor[index] );
        //
      });
      // dataset_apexchart.push({
      //     data: [4,5],
      //     name: "brit",
      //   });
      // dataset_apexchart.push({
      //     data: [5,3],
      //     name: "sce",
      //   });
      // this.apexdata_label.push("decembre 2020");
      //console.log( "dataset_apexchart ==== line 2490 :::", dataset_apexchart,  dataset_apexchart.length );

      this.dataset_apexchart = dataset_apexchart;

      //console.log("this.apexdata_label :::: ", this.apexdata_label);
      // if (dataset_apexchart.length >0){
      // //console.log("this.dataset_apexchart in cor graph  ::::", dataset_apexchart );
      this.apex_data = {
        series: dataset_apexchart,
        type: "bar",
        chartOptions: {
          chart: {
            type: "bar",
            height: 300,
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          xaxis: {
            type: "String",
            categories: this.apexdata_label,
          },
          colors: backgroundColor,

          fill: {
            colors: backgroundColor,
          },
          dataLabels: {
            style: {
              colors: backgroundColor,
            },
          },
          markers: {
            colors: hoverBackgroundColor,
          },
          // grid: {
          //     row: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     },
          //     column: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     }
          //   },
          legend: {
            show: true,
            position: "top",
            offsetY: 40,
          },
          fill: {
            opacity: 1,
          },
        },
      };

      this.isLoading_apex_data = false;
      this.apex_dataConfig();
      // }
      // if(this.dataset_apexchart){
      //   //console.log("dataset_apexchart", dataset_apexchart);
      // }
    },
    getapexradarData(result_monthdata) {
      ////console.log("result_monthdata apex11111 ========", result_monthdata);

      var dataset_apexchart_radar = [];
      var backgroundColor = [
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
      ];
      var hoverBackgroundColor = [
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
      ];

      var apexdata_radar = [];
      var category_name = [];
      // this.apexdata_radar_label.forEach((category, index) => {

      //       if(category.split(" ")[1] === 'Time')
      //         {
      //           backgroundColor[index]="#eeff41"
      //           hoverBackgroundColor[index]="#eeff41"
      //         }
      //       if(category.split(" ")[1] === 'Price')
      //         {
      //           backgroundColor[index]="#3d3d3d"
      //           hoverBackgroundColor[index]="#3d3d3d"
      //         }
      //       if(category.split(" ")[1] === 'Place')
      //         {
      //           backgroundColor[index]="#D3C5FF"
      //           hoverBackgroundColor[index]="#D3C5FF"
      //         }
      //       if(category.split(" ")[1] === 'Location')
      //         {
      //           backgroundColor[index]="#b08fff"
      //           hoverBackgroundColor[index]="#b08fff"
      //         }
      //       if(category.split(" ")[1] === 'Brand')
      //         {
      //           backgroundColor[index]="#5700ff"
      //           hoverBackgroundColor[index]="#5700ff"
      //         }
      //       if(category.split(" ")[1] === 'Products'){
      //         backgroundColor[index]="#7c7c7c"
      //         hoverBackgroundColor[index]="#7c7c7c"
      //       }
      //       if(category.split(" ")[1] === 'Staff'){
      //         backgroundColor[index]="#CCCCCC"
      //         hoverBackgroundColor[index]="#CCCCCC"
      //       }
      //       if(category === 'Others'){
      //         backgroundColor[index]="#FAFF99"
      //         hoverBackgroundColor[index]="#FAFF99"
      //       }
      //     });
      // this.categories.forEach((category, index) => {
      // this.apexdata_radar_label.forEach((month)=>{
      // ////console.log("month in apexdata $$$$$$$$$$", month);
      var count = 0;
      var avg_star_rating = 0;
      var star_rating = 0;

      result_monthdata.forEach((item) => {
        // if ((month === moment(item.month).format('MMM YYYY')) && (category == item.category_name)){
        // if (category == item.category_name) {
        // ////console.log(" category ::: item.category_name :: " ,category , item.month ,item.sum_avg_star_rating);
        // count = item.count;
        // star_rating = item.sum_avg_star_rating;
        // if (star_rating === 0 && count == 0) {
        //   avg_star_rating=0;
        // } else {
        //   avg_star_rating = star_rating / count;
        // }
        // avg_star_rating = item.review_star_rating_avg;
        // if(category === item.category_id[1])
        avg_star_rating = item.review_star_rating_avg;
        // }
        apexdata_radar.push(parseFloat(avg_star_rating.toFixed(2)));
      });
      // //console.log( "avg_star_rating ::::::::",  star_rating, count, avg_star_rating ? 0 : avg_star_rating );
      // category_name.push(category);

      // ////console.log("item for each month :: ", month, scoretag.name, count);

      // category.push(category);
      // });
      // ////console.log("category in apexdata radar  $$$$$$$$$$", apexdata , category, index ,backgroundColor[index], hoverBackgroundColor[index] );
      //
      // });
      // //console.log("this.categories ::: ", category_name);
      dataset_apexchart_radar.push({
        data: apexdata_radar,
        name: "Star Rating",
      });
      // //console.log("dataset_apexchart radar ==== ", apexdata_radar, dataset_apexchart_radar);
      this.dataset_radar_apexchart = dataset_apexchart_radar;
      //console.log( "this.apexdata_radar_label::::::",  dataset_apexchart_radar, this.apexdata_radar_label );
      this.apex_data_radar = {
        series: dataset_apexchart_radar,
        type: "radar",
        chartOptions: {
          chart: {
            type: "radar",
            height: 300,
          },

          colors: backgroundColor,

          fill: {
            colors: backgroundColor,
          },
          dataLabels: {
            style: {
              colors: backgroundColor,
            },
          },
          markers: {
            colors: hoverBackgroundColor,
          },
          // grid: {
          //     row: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     },
          //     column: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     }
          //   },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          xaxis: {
            type: "String",
            categories: this.apexdata_radar_label,
          },
          legend: {
            position: "top",
            offsetY: 20,
          },
          fill: {
            opacity: 0.1,
          },
        },
      };
      this.apex_radar_dataConfig();
    },
    barchartdata(result_monthdata) {
      // ////console.log("this.barchartscoredata_label ,this.barchartscoredata", this.barchartscoredata_label ,this.barchartscoredata);

      var dataset_barchart = [];
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      //console.log("this.scoreTags ::: ", this.scoreTags);
      var scoretag_sorted = _.sortBy(this.scoreTags, "name").reverse();
      //console.log("scoretag_sorted ::: ", scoretag_sorted);
      scoretag_sorted.forEach((scoretag, index) => {
        var bardata = [];
        if (scoretag.name === "N") {
          backgroundColor[index] = "#7c7c7c";
          hoverBackgroundColor[index] = "#7c7c7c";
        }
        if (scoretag.name === "N+") {
          backgroundColor[index] = "#eeff41";
          hoverBackgroundColor[index] = "#eeff41";
        }
        if (scoretag.name === "NEU") {
          backgroundColor[index] = "#3d3d3d";
          hoverBackgroundColor[index] = "#3d3d3d";
        }
        if (scoretag.name === "NONE") {
          backgroundColor[index] = "#D3C5FF";
          hoverBackgroundColor[index] = "#D3C5FF";
        }
        if (scoretag.name === "P") {
          backgroundColor[index] = "#b08fff";
          hoverBackgroundColor[index] = "#b08fff";
        }
        if (scoretag.name === "P+") {
          backgroundColor[index] = "#5700ff";
          hoverBackgroundColor[index] = "#5700ff";
        }
        if (!scoretag.name) {
          backgroundColor[index] = "#CCCCCC";
          hoverBackgroundColor[index] = "#CCCCCC";
        }
        //console.log( "backgroundColor[index], scoretag ::: ",  backgroundColor[index],scoretag.name );

        this.barchartscoredata_label.forEach((month) => {
          // ////console.log("month in barchartscoredata $$$$$$$$$$", month);
          var count = 0;
          result_monthdata.forEach((item) => {
            // //console.log("month === moment(item.month).forma && scoretag.name == item.score_tag ", month , item.month);
            if (month === item.month && scoretag.name == item.score_tag) {
              count += item.count;
            }
          });
          // ////console.log("item for each month :: ", month, scoretag.name, count);

          bardata.push(count);
        });
        // ////console.log("scoretag in barchartscoredata  $$$$$$$$$$", scoretag.name, index ,backgroundColor[index], hoverBackgroundColor[index]);
        //console.log("bardata ::: ", bardata);
        //console.log("bardata ::: ", bardata);
        dataset_barchart.push({
          label: scoretag.name,
          data: bardata,
          backgroundColor: backgroundColor[index],
          hoverBackgroundColor: hoverBackgroundColor[index],
          hoverBorderWidth: 0,
        });
        // //console.log("dataset_barchart ::: ", dataset_barchart);
        //
      });
      //console.log("dataset_barchart ::: ", dataset_barchart);

      this.barchartDatacollection = {
        labels: this.barchartscoredata_label,
        datasets: dataset_barchart,
        options: {
          scales: {
            xAxes: [
              {
                stacked: true,
                // gridLines: { display: true }
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
          legend: { display: true },
          // height: "100%",
          // width: "100%"
        },
      };
    },
  },
  watch: {
    partnerSelected: function (partnerSelected) {
      var partner_ids = [];
      // partnerSelected.forEach((partner) => {
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      //   partner_ids.push(partner.id);
      // });
      //console.log("partner selected", partnerSelected, partner_ids);
      this.locationSelected = [];
      // this.partnerSelected = "";
      this.scoretagSelected = "";
      this.starratingSelected = [];
      this.topicSelected = "";

      if (partner_ids.length > 0) {
        partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        // this.getlocation();
        this.getBusinessUnits();
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();

        // this.getstarRating();
        // this.getCategoryNameTopics();
        // this.getdatastudioSentiment();
        // this.getdatastudioTopics();

        // this.getanalyzeInsightFirst();
        // this.getanalyzeInsightThird();
        // this.getanalyzeInsightFourth();
        // this.getanalyzeInsightFifth();
      } else {
        this.locations = [];
        this.locationSelected = [];
        this.businessunitSelected = [];
        this.businessUnits = [[]];
        this.scoretagcommentCount = [];
        this.score_data = [];
        this.insights = [];
        this.category = [];
        this.barchartscoredata_label = [];
        this.barchartDatacollection.label = [];
        this.apexdata = [];
        this.apex_dataconfig_data = {
          dataSource: {
            type: "bar",
            chartOptions: {
              chart: {
                type: "bar",
                height: 300,
                stacked: true,
                toolbar: {
                  show: true,
                },
                zoom: {
                  enabled: true,
                },
              },
            },
          },
        };
        this.apex_dataconfig_data_radar = {
          dataSource: {
            type: "radar",
            chartOptions: {
              chart: {
                type: "radar",
                height: 300,
              },
            },
          },
        };
        this.barchartDatacollection = { labels: [], datasets: [], options: {} };
        this.topic_avg_starrating_data = [];

        this.dataset_apexchart = [];

        this.apexdata_label = [];
        this.barchartscoredata_label = [];
        this.form_count_data = [];
        this.topic_form_data = [];
        this.topic_starrating_data = [];

        // this.demographicExcludeSelected=[];
        this.starRatings = [];
        this.scoreTags = [];
        this.topics = [];
        this.starratingSelected = [];
        this.topicSelected = "";
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>